import { SET_REFERAL_SETTINGS } from '../actions/actionTypes';

const initialState = {
    isEnabled: false,
    referLink: '',
    refererPayeeReward: 0,
    referredPayeeReward: 0,
    rewardCurrencySymbol: '',
    referCode: ''
}
function ReferalReducer(state = initialState, action) {
    switch (action.type) {
        case SET_REFERAL_SETTINGS:
            return {
                ...state,
                ...action.payload
            }

        default: return state;
    }
}
export default ReferalReducer;